import { IProps } from '@/Interfaces/Icons/Props.interface';
import classNames from 'classnames';

const TargetIcon = ({ className, ...props }: IProps) => {
  return (
    <svg
      className={classNames('target-icon', className)}
      width='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8 5.33335C6.52724 5.33335 5.33333 6.52726 5.33333 8.00002C5.33333 9.47277 6.52724 10.6667 8 10.6667C9.47276 10.6667 10.6667 9.47277 10.6667 8.00002H12C12 10.2092 10.2091 12 8 12C5.79086 12 4 10.2092 4 8.00002C4 5.79088 5.79086 4.00002 8 4.00002V5.33335Z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.00008 2.00001C4.68637 2.00001 2.00008 4.6863 2.00008 8.00001C2.00008 11.3137 4.68637 14 8.00008 14C11.3138 14 14.0001 11.3137 14.0001 8.00001C14.0001 7.58818 13.9587 7.1867 13.88 6.79929L15.1867 6.53405C15.283 7.00827 15.3334 7.49859 15.3334 8.00001C15.3334 12.0501 12.0502 15.3333 8.00008 15.3333C3.94999 15.3333 0.666748 12.0501 0.666748 8.00001C0.666748 3.94992 3.94999 0.666672 8.00008 0.666672C8.50149 0.666672 8.99182 0.717093 9.46604 0.813354L9.20079 2.12004C8.81339 2.0414 8.41191 2.00001 8.00008 2.00001Z'
      />
      <path
        fill='currentColor'
        d='M13.1571 1.2353C13.121 1.05448 12.9882 0.908246 12.8117 0.85481C12.6352 0.801375 12.4437 0.849414 12.3133 0.979803L10.1668 3.12625V4.89055L7.52881 7.52858L8.47162 8.47139L11.1096 5.83336L12.8739 5.83336L15.0204 3.68691C15.1508 3.55652 15.1988 3.36495 15.1454 3.18847C15.0919 3.01198 14.9457 2.87923 14.7649 2.84307L13.4251 2.57511L13.1571 1.2353Z'
      />
    </svg>
  );
};

export default TargetIcon;
